export default __webpack_public_path__ + "static/media/10.5da4bd6d.png";